// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__o_rTm","right":"Footer_right__2zVWU","buttons":"Footer_buttons__qsbG4"};